import { LineChartForAllBranches } from "../util/adminDashboard/lineChartForBranches";

import LinChart from "./LineChart";
import { Line } from "react-chartjs-2";
import classes from "./LineChartForBranches.module.css";

export default function LineChartForBranches({ data }) {
  const d1 = LineChartForAllBranches(data[0]);
  const d2 = LineChartForAllBranches(data[1]);

  if (d1 == null) return;
  return (
    <>
      <div className={classes.chartContainer}>
        <h3>1 Star Ratings</h3>
        <Line data={d1} />
      </div>

      <div className={classes.chartContainer}>
        <h3>5 Star Ratings</h3>
        <Line data={d2} />
      </div>
    </>
  );
}
